import { ReactNode } from 'react';

import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';
import styles from 'KnmErknmPackage/ErknmViolationsModule/components/ViolationStatus.module.scss';

export const mapViolationStatusToTooltip: Partial<Record<ViolationStatusesEnum, ReactNode>> = {
  [ViolationStatusesEnum.APPEALED]: (
    <div className={styles.TooltipContent}>
      Статус «Успешно обжаловано» присваивается нарушению в случае, если нарушение было обжаловано в пользу заявителя.
    </div>
  ),
  [ViolationStatusesEnum.FIXED]: (
    <div className={styles.TooltipContent}>
      Статус «Устранено» присваивается нарушению в одном из следующих случаев:
      <br />
      1. Нарушение было устранено;
      <br />
      2. Нарушение было устранено в ходе мероприятия;
      <br />
      3. Инспектором подтверждено устранение нарушения по предоставленным материалам;
      <br />
      4. Инспектором зафиксировано устранение нарушения в рамках другого мероприятия.
    </div>
  ),
  [ViolationStatusesEnum.APPROVING]: (
    <div className={styles.TooltipContent}>
      Статус «Ожидает подтверждения» присваивается нарушению в случае, если не заполнена оценка исправления нарушения в
      записи представленного материала, подтверждающего устранение нарушения.
    </div>
  ),
};
